import { Routes } from '@angular/router';

import { HomeComponent } from '../../home/home.component';
import { UserComponent } from '../../user/user.component';
import { TransactionComponent } from '../../transaction/transaction.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';
import { AttemptHistoryComponent } from 'app/attempt-history/attempt-history.component';
import { PaymentHistoryComponent } from 'app/payment-history/payment-history.component';

export const AdminLayoutRoutes: Routes = [
    { path: 'dashboard', component: HomeComponent },
    { path: 'user', component: UserComponent },
    { path: 'transactions', component: TransactionComponent },
    { path: 'upgrade', component: UpgradeComponent },
    { path: 'attempts-history', component: AttemptHistoryComponent },
    { path: 'payments-history', component: PaymentHistoryComponent },
];
